// extracted by mini-css-extract-plugin
export default {"container":"menu_container__1iov8","items":"menu_items__33GDZ"};